export default __webpack_public_path__ + "static/media/google-meet.627544f9.svg";